import React from "react";

export default function ProductDetailsIcon({ className }) {
  return (
    <svg
      width="100%"
      height="100%"
      x="0"
      y="0"
      viewBox="0 0 266.733 266.732"
      className={className}
    >
      <g>
        <path
          d="m129.991 68.594-14.935 11.833c-3.502-.91-7.37-.264-10.417 2.154l-41.306 32.737c-3.055 2.417-4.564 6.032-4.482 9.649l-22.815 18.078c-7.304 5.787-11.514 14.473-11.852 24.451-.327 9.539 2.973 19.177 9.275 27.129 6.303 7.958 14.93 13.367 24.292 15.229 2.371.471 4.721.7 7.031.7 7.201 0 13.945-2.278 19.478-6.66l93.949-74.454a7.17 7.17 0 0 0 1.166-10.069 7.173 7.173 0 0 0-10.071-1.167l-93.95 74.452c-3.949 3.127-9.201 4.237-14.807 3.127-6.027-1.199-11.656-4.774-15.847-10.072-4.196-5.292-6.394-11.593-6.184-17.734.191-5.698 2.476-10.566 6.426-13.693l22.806-18.075c.99.252 1.993.42 3.013.42 2.6 0 5.218-.845 7.411-2.586l41.306-32.737c3.055-2.417 4.564-6.03 4.483-9.645l14.937-11.835a7.177 7.177 0 0 0 1.167-10.072 7.174 7.174 0 0 0-10.074-1.16z"
          fill="currentColor"
          opacity="1"
          dataOriginal="currentColor"
        ></path>
        <path
          d="M89.308 150.556a7.165 7.165 0 0 0 10.069 1.166l93.953-74.449c4.019-3.188 9.218-4.436 14.683-3.519 5.722.961 10.986 4.158 14.822 9.005 7.748 9.773 7.117 23.217-1.404 29.975l-93.958 74.449a7.169 7.169 0 0 0-1.167 10.066 7.138 7.138 0 0 0 5.626 2.717 7.14 7.14 0 0 0 4.45-1.55l93.958-74.451c14.716-11.666 16.386-34.143 3.738-50.113-6.049-7.628-14.458-12.685-23.686-14.239-9.497-1.591-18.724.684-25.968 6.42l-93.95 74.456c-3.102 2.454-3.623 6.963-1.166 10.067zM164.959 60.522l4.999-13.364-1.06-1.327-14.15 1.806-11.645 9.229 11.547 1.337-1.34 11.547zM185.728 23.088l-11.649 9.222 11.546 1.344-1.33 11.547 11.644-9.234 4.994-13.358-1.055-1.332zM222.789 14.694l4.994-13.366L226.728 0l-14.15 1.811-11.645 9.229 11.542 1.337-1.33 11.546zM101.762 206.21l-4.993 13.367 1.05 1.33 14.15-1.811 11.647-9.222-11.546-1.345 1.339-11.546zM80.992 243.649l11.641-9.226-11.546-1.34 1.34-11.546-11.647 9.232-4.994 13.361 1.05 1.33zM43.93 252.041l-4.993 13.357 1.057 1.334 14.15-1.81 11.647-9.227-11.546-1.34 1.332-11.545z"
          fill="currentColor"
          opacity="1"
          dataOriginal="currentColor"
        ></path>
      </g>
    </svg>
  );
}
